export default "/images/vendor/flag-icon-css/flags/1x1/qa.svg?c08921ec8cdc1b1a0e8e7f818cfdbe2f";